import React from 'react';
import WarningIcon from '../../containers/WarningIcon';

const IEUniversityMessage = () => {
  return (
    <div className="no-study-message" style={{ maxWidth: '1400px' }}>
      <WarningIcon />
      <p>
        MRI-Simmons Turn-Key Omnibus is a Do-It-Yourself intelligence tool, that
        enables marketers to quickly unearth the latest consumer behaviors via
        short surveys and measure the impact of those behaviors by fusing the
        results with MRI-Simmons' National Studies. The fusion provides
        marketers with proprietary, actionable insights in days. Please contact
        your MRI-Simmons account representative to gain access to this
        functionality.
      </p>
    </div>
  );
};

export default IEUniversityMessage;
